import cx from "classnames";
import styles from "../assets/sass/Loader.module.sass";
import { useEffect } from "react";
import { Triangle } from "react-loader-spinner";

const Loader = ({
  loading,
  position = "fixed",
  transparentBg = false,
  setIsLoading = null,
  height = 64,
  width = 64,
  strokeWidth = 4,
  color = "#1890ff",
}) => {
  useEffect(() => {
    setIsLoading?.(true);
    return () => setIsLoading?.(false);
  }, []);

  if (!loading) return null;

  return (
    <div
      className={cx(
        styles.container,
        styles[position],
        transparentBg ? styles.transparentBg : ""
      )}
    >
      <div className={styles.loaderNew}>
        <Triangle
          ariaLabel="loading-indicator"
          height={height}
          width={width}
          strokeWidth={strokeWidth}
          color={color}
        />
      </div>
    </div>
  );
};

export default Loader;
